import * as React from "react";
import { Pagination, TabbedForm, FormTab, List, useRecordContext, Datagrid, TextField, NumberInput, EmailField, TextInput, ReferenceInput, SelectInput, ReferenceField, Edit, SimpleForm, useGetList, useDataProvider, Create, required, DateTimeInput } from 'react-admin';

import { CatalogProductList } from "../components/catalogProductList";

import { PageListTitle, PageEditTitle, PageCreateTitle } from "../components/pageTitles";
import {default as commonStyles} from "./../styles/common.js";
import Stack from '@mui/material/Stack';

export const CatalogList = props => (
    <List exporter={false} {...props} pagination={<Pagination rowsPerPageOptions={[10, 50]} />}>
        <PageListTitle text="Liste des catalogues"/>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="name" />
        </Datagrid>
    </List>
);

export const CatalogEdit = props => {
    const record = useRecordContext();
    return (
        <Edit {...props}>
            <PageEditTitle text="Édition du catalogue"/>
            <TabbedForm>
                <FormTab label="general">
                    <Stack direction="column" style={commonStyles.stackColumn} spacing={2}>
                        <CatalogEditDefaultPrevention style={commonStyles.inputStyle} />
                        <TextInput style={commonStyles.inputStyle} disabled source="id" label="Id" />
                        <CatalogEditNameInput />
                    </Stack>
                </FormTab>
                <FormTab label="produits">
                    <CatalogProductList canCreate={true}  />
                </FormTab>
            </TabbedForm>
        </Edit>
    )
};

export const CatalogCreate = props => (
    <Create {...props}>
        <PageCreateTitle text="Création d'un catalogue"/>
        <SimpleForm>
            <TextInput source="name" validate={required()} />
        </SimpleForm>
    </Create>
);

const CatalogEditDefaultPrevention = (props) => {
    const record = useRecordContext();
    if (!record) return null;
    if(record.id != 1) return null;
    return <span style={{ ...props.style, color: 'red'}}>Le nom du catalogue par défaut n'est ni modifiable ni supprimable.</span>
};

const CatalogEditNameInput = (props) => {
    const record = useRecordContext();
    if (!record) return null;
    if(record.id == 1) return <TextInput  style={commonStyles.inputStyle} source="name" disabled />;
    return <TextInput  style={commonStyles.inputStyle} source="name" validate={required()} />;
};